module.exports = __webpack_public_path__ + "static/media/5.c91159f7.png";